import { querySubAccountAuthMallList } from "@/api/sub_account";
import {
  AuthMallListItem,
  AuthMallStatusEnums,
  SubAccountListItem,
} from "@/api/sub_account/interface";
import { Button, Input, Table, Toast, Modal } from "@ad/anq-ui";
import { useLoadingFn } from "@afe/rocket-hooks";
import React, { useEffect, useState } from "react";
import { mallInfoColumns } from "./common";

import styles from "src/views/account_management/styles.module.scss";

interface Props {
  visible: boolean;
  onClose: () => void;
  record: SubAccountListItem;
  onManageMall?: (gotoAdd?: boolean) => void;
}

const ModalMallAuth = ({
  visible,
  onClose,
  record,
  onManageMall,
}: Props) => {
  const [mallList, setMallList] = useState<AuthMallListItem[]>([]);
  const [filterString, setFilterString] = useState("");

  useEffect(() => {
    if (visible && record?.uid) {
      getMallList();
    }
  }, [visible, record?.uid]);

  const [mallListLoading, getMallList] = useLoadingFn(async () => {
    const res = await querySubAccountAuthMallList({ uid: record.uid });

    if (res?.success) {
      setMallList(res.result.authMallList);
    } else {
      Toast.error(res?.errorMsg || "获取店铺列表失败");
    }
  });

  const handleClose = () => {
    onClose();
    setMallList([]);
  };

  const columns = [...mallInfoColumns];

  const dataSource = mallList.filter(
    (item) => item.status === AuthMallStatusEnums.HAS_AUTH
  );

  return (
    <>
      <Modal
        visible={visible}
        title="店铺权限"
        onCancel={handleClose}
        width={640}
        maskClosable
        centered
        footer={
          <div style={{ overflow: "hidden" }}>
            {!record?.mallOwner && (
              <Button
                onClick={() => onManageMall(false)}
                style={{ float: "left", lineHeight: "32px" }}
                type="link"
              >
                管理店铺权限
              </Button>
            )}
            <div style={{ float: "right" }}>
              <Button type="primary" onClick={handleClose}>
                确定
              </Button>
              <Button onClick={handleClose}>取消</Button>
            </div>
          </div>
        }
      >
        <div style={{ marginBottom: 24, lineHeight: "32px" }}>
          <span style={{ fontSize: 12 }}>
            共 <span style={{ color: "#4C67FF" }}>{dataSource.length}</span>{" "}
            个店铺
          </span>
          <Input.Search
            value={filterString}
            onChange={(e) => setFilterString(e.target.value)}
            placeholder="请输入店铺名称、店铺 ID"
            style={{ width: 320, float: "right" }}
            allowClear
          />
        </div>
        <Table
          columns={columns}
          size="small"
          dataSource={dataSource.filter(
            (item) =>
              item.mallName.includes(filterString) ||
              item.mallId.toString().includes(filterString)
          )}
          className={styles.table}
          rowKey="mallId"
          pagination={false}
          loading={mallListLoading}
          scroll={dataSource.length > 9 ? { y: 338 } : undefined}
          emptyText={
            <>
              {record?.mallOwner ? (
                "暂无数据"
              ) : (
                <span>
                  暂无数据，前往{" "}
                  <span
                    className="dmp-link"
                    style={{ color: "#4C67FF", textDecoration: "underline" }}
                    onClick={() => onManageMall(true)}
                  >
                    添加店铺
                  </span>
                </span>
              )}
            </>
          }
        />
      </Modal>
    </>
  );
};

export default ModalMallAuth;
